import React from 'react';
import SafeIcon from '../common/SafeIcon';
import { FiBookOpen } from 'react-icons/fi';

const Footer = () => {
  return (
    <footer className="bg-stone-950 text-stone-400 py-12 border-t border-stone-800">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6">
          <div className="flex items-center gap-2 text-xl font-serif font-bold text-stone-200">
            <SafeIcon icon={FiBookOpen} className="text-amber-600" />
            <span>Bible Bookmark</span>
          </div>
          <div className="flex gap-6 text-sm">
            <a href="#" className="hover:text-amber-500 transition-colors">Terms of Use</a>
            <a href="#" className="hover:text-amber-500 transition-colors">Privacy Policy</a>
            <a href="#" className="hover:text-amber-500 transition-colors">Contact Support</a>
          </div>
        </div>
        <div className="mt-8 text-center text-sm border-t border-stone-800 pt-8">
          <p>&copy; {new Date().getFullYear()} Bible Bookmark. All rights reserved.</p>
          <p className="mt-2 text-xs">Remember: This is a digital product bundle. No physical items will be shipped.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;